<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2>فصل ها</h2>
            </div>
        </div>
        <!-- end main title -->
        <!-- form -->
        <div class="col-12">
            <div class="form">
                <div class="row">


                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group">
                                    <input v-model="name" type="text" class="form__input" placeholder="عنوان">
                                </div>
                            </div>


                        </div>
                    </div>


                    <div class="col-12">
                        <div class="row">

                            <div class="col-12">
                                <button type="button" class="form__btn" @click="insert_data">{{status_form ==0 ?
                                    'افزودن' : 'ویرایش'}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">

            <div class="row">
                <!-- main title -->
                <!-- end main title -->

                <!-- users -->
                <div class="col-12" v-for="season in items" style="margin-bottom: 40px">
                    <div style=" display: flex;color: white">
                        <label>{{season.name}}</label>
                        <div @click="edit_item(season)" datas="#"
                             class="main__table-btn main__table-btn--edit">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"/>
                            </svg>
                        </div>
                        <div @click="add_episode(season)" datas="#"
                             class="main__table-btn main__table-btn--edit">
                            <svg enable-background="new 0 0 50 50" height="50px" id="Layer_1" version="1.1"
                                 viewBox="0 0 50 50" width="50px" xml:space="preserve"
                                 xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect fill="none" height="50" width="50"/>
                                <line fill="none" stroke="#2fed92" stroke-miterlimit="10" stroke-width="4" x1="9"
                                      x2="41" y1="25" y2="25"/>
                                <line fill="none" stroke="#2fed92" stroke-miterlimit="10" stroke-width="4" x1="25"
                                      x2="25" y1="9" y2="41"/></svg>
                        </div>
                    </div>
                    <div style="padding: 5px;border: 1px solid white;border-radius: 10px" class="row">
                        <div v-for="episode in season.episodes" class="col-2" style="padding: 3px;color: white;">
                            <div style="padding: 3px; border: 1px solid grey;display: grid;position: relative;text-shadow: 1px 1px 4px black;">
                                <img  :src="episode.image" style="height: 100%;position: absolute"/>
                                <label style="z-index: 100;">{{episode.name}}</label>
                                <label style="z-index: 100;">{{episode.duration}}</label>

                                <div style="z-index: 100;" @click="edit_episode(episode,season)" datas="#"
                                     class="main__table-btn main__table-btn--edit">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"/>
                                    </svg>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>


            </div>
        </div>
        <!-- end form -->
    </div>
</template>

<script>
    import axios from "axios";
    // import {bus} from '../main';
    import Datatable from "@/views/customTable/Datatable";

    export default {
        name: 'ItemsList',
        data() {
            return {
                items: [],

                status_form: 0,
                name: '',
            }
        },
        components: {
            Datatable
        },
        mounted() {
            this.get_data();
        },
        methods: {
            edit_item(item) {
                this.name = item.name
                this.status_form = item.id
            },
            edit_episode(item, season) {
                this.$router.push({path: '/episode/' + season.id + "/" + item.id})
            },
            add_episode(item) {
                this.$router.push({path: '/episode/' + item.id + "/0"})
            },
            get_data() {

                var self = this;

                var formData = new FormData();

                formData.append('poster_id', this.$route.params.id)
                this.axios.post('get_seasons', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.items = content_data

                }).catch(function (error) {
                    console.log(error);
                });


            },
            insert_data() {

                var self = this;
                if (this.name == "") {
                    return
                }
                var formData = new FormData();
                var url = 'insert_seasons'
                formData.append('name', this.name);
                formData.append('poster_id', this.$route.params.id);

                if (this.status_form != 0) {
                    formData.append('id', this.status_form);
                    url = 'edit_seasons'
                }
                this.axios.post(url, formData, {}).then(function (response) {

                    self.get_data()
                    self.name = ''
                    self.status_form = 0;
                    self.$toast.success('ثبت با موفقیت انجام شد');


                }).catch(function (error) {
                    console.log(error);
                    self.$toast.error('خطا در ثبت اطلاعات');

                });


            },

        }
    }
</script>

